<template>
  <div v-if="legend">
    <div class="legend">
      <div class="legend-level" v-for="level in legend.levels" :key="level.name">
        <span class="legend-level__color" :style="{background: level.color}"></span>
        <span class="legend-level__label">{{level.label}}</span>
      </div>
    </div>
    <div class="coverage" v-if="currentCoverage && network">
      <span class="coverage__info" v-if="locationAddress">Address: {{locationAddress || 'No address'}}</span>
      <span class="coverage__info">
        Outdoor coverage in your area for
        <span class="coverage__info__inline">{{network.label}}</span>
        <span v-if="currentCoverage.label">is</span>
        <span class="coverage__info__inline" v-if="currentCoverage.label">{{currentCoverage.label}}</span>
        <span class="coverage__info__inline" v-else>cannot be identified</span>
        <div class="container" v-if="currentCoverage.label">
          <span class="coverage__color" :style="{background: currentCoverage.color}"></span>
          <a class="coverage__link" v-if="currentCoverage.link" target="_blank" :href="currentCoverage.link">{{ currentCoverage.text || currentCoverage.link }}</a>
        </div>
      </span>
    </div>
    <div class="data-of" v-if="legend.dateOfData || legend.dateOfData5g">
      <span class="data-of__info">Coverage updates when you change Service Provider/Technology and select address</span>
      <!-- <span class="data-of__info" v-if="network.name === 'three' || network.parentOperator === 'three'"><b>The results displayed omit a small percentage of sites. <a href="https://www.three.ie/coverage-checker/info/" target="_blank">Click here</a> for details.</b></span> -->
      <span class="data-of__info" v-if="legend.dateOfData && legend.dateOfData !== legend.dateOfData5g">
        ComReg requested 2G, 3G, 4G data by {{legend.dateOfData | date}}
      </span>
      <span class="data-of__info" v-if="legend.dateOfData5g && legend.dateOfData !== legend.dateOfData5g">
        ComReg requested 5G data by {{legend.dateOfData5g | date}}
      </span>
      <span class="data-of__info" v-if="legend.dateOfData === legend.dateOfData5g">
        ComReg requested data by {{legend.dateOfData | date}}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters('map', ['locationAddress', 'networkName', 'technologyName',
      'legend', 'currentCoverage', 'location', 'bounds', 'zoom', 'network'])
  },
  methods: {
    ...mapActions('map', ['loadLegend', 'loadCurrentCoverage']),

    load() {
      this.loadLegend();
      if (!this.location || !this.bounds || !this.zoom) return;
      this.loadCurrentCoverage();
    }
  },
  watch: {
    networkName: function () {
      this.load();
    },
    technologyName: function () {
      this.load();
    },
    location: {
      deep: true,
      handler: function () {
        this.load();
      }
    },
    bounds: {
      deep: true,
      handler: function () {
        this.load();
      }
    },
    zoom: function () {
      this.load();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import 'nib'

$legendHeight = 22px

.legend
  row()
  margin 10px 0
  min-height $legendHeight
  height $legendHeight
  relative top left
  width 100%
  box-sizing border-box
  .legend-level
    row()
    border 1px solid #666666
    flex-grow 1
    justify-content center
    align-items center
    height 100%
    border-right none
    relative top left
    &:last-child
      border-right 1px solid #666666
    &__color
      absolute top left
      width 100%
      height 100%
      opacity 0.55
    &__label
      row()
      $labelSize = 12px
      absolute bottom (-1.3 * $labelSize - 3px) left 0
      color #666666
      width 100%
      font-size $labelSize
      height $labelSize * 1.3
      justify-content center
      &:after
        content ''
        height 3px
        width 1px
        background #666666
        absolute bottom 1.2 * $labelSize center

.coverage
.data-of
  notSelectable()
  margin-top 15px
  &__info
    display block
    font-family "Open Sans"
    align-items center
    font-size 14px
    margin-top 10px
    font-weight 500
    & a
      color #0055a4
    &__inline
      display inline
      font-weight bold
  &__color
    display block
    $colorBlock = 22px
    height $colorBlock
    width $colorBlock * 3
    border 1px solid black
    margin-right auto
    opacity 0.55

.coverage
  margin-top 60px

.container
  margin-top 6px
  display grid
  grid-template-columns max-content 1fr
  align-items center
  gap 8px

  .coverage__link
    text-overflow ellipsis
    overflow hidden
    font-weight 400
</style>
